export interface Role {
  roleId: number | string;
  name?: string;
  displayName?: string;
  description?: string;
}

export interface MenuItem {
  id: number;
  name: string;
  assigned?: boolean;
  subMenu?: MenuItem[];
}

export interface UserRole extends Record<string, unknown> {
  empName?: string;
  ccEmail?: string;
  employeeType?: string;
  department?: string;
  designation?: string;
  roles?: string[];
}

export interface ListResponse<T> {
  data: T[] | null;
  totalRoles?: number;
  totalRequest?: number;
  totalPages?: number;
  code?: string | number;
  message?: string;
}

export const roleLabel = (role: Role) => role.displayName || role.name || "Untitled role";
